import api from "./api";
import { DashboardQuery } from "../models/Dashboard";
import {
  DeleteProcessCommand,
  EditProcessCommand,
  ProcessDeletionViewModel,
  ProcessStatusTimeline,
} from "../models/Process";

export const getDashboard = async (filter?: DashboardQuery) => {
  try {
    const response = await api.get(`/api/process/dashboard`, {
      params: filter,
    });

    return response.data;
  } catch (error) {
    console.log("error", error);
  }
};

export const getFinancial = async (filter?: DashboardQuery) => {
  try {
    const response = await api.get(`/api/process/financial`, {
      params: filter,
    });
    if (!response.data.success) {
      console.log("error", response.data);
    }
    return response.data;
  } catch (error) {
    console.log("error", error);
  }
};

export const getLastRef = async () => {
  try {
    const response = await api.get(`/api/process/lastRef`);
    if (!response.data.success) {
      console.log("error", response.data);
    }
    return response.data;
  } catch (error) {
    console.log("error", error);
  }
};

export const importItems = async (file: File, processId: string) => {
  const formData = new FormData();
  formData.append("file", file);
  const response = await api.post(`/api/process/${processId}/saveItems`, formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  if (!response.data.success) {
    throw new Error(response.data.notifications?.join(", ") || "A importação não foi concluída.");
  }
  return response;
};

export const getProcesses = async (filter?: DashboardQuery) => {
  try {
    const response = await api.get(`/api/process`, { params: filter });
    return response.data;
  } catch (error) {
    console.log("error", error);
  }
};

// Retorna todos os processos com esse número: o mesmo número existe em filiais diferentes
// (ex.: "ALFA 1451" e "D-RO 1451"), então quem digita escolhe qual.
export const getProcessesByCvfRef = async (cvfRef: string) => {
  try {
    const response = await api.get(
      `/api/process/ProcessesByCvfRef?cvfRef=${encodeURIComponent(cvfRef)}`
    );
    return response.data;
  } catch (error) {
    console.log("error", error);
  }
};

export const getProcessById = async (id: string) => {
  try {
    const response = await api.get(`/api/process/${id}`);
    if (!response.data.success) {
      console.log("error", response.data);
    }
    return response.data;
  } catch (error) {
    console.log("error", error);
  }
};

export const updateProcess = async (process: EditProcessCommand) => {
  try {
    const response = await api.put(`/api/process/${process.id}`, process);
    if (!response.data.success) {
      console.log("asd-error", response.data);
    }
    return response;
  } catch (error) {
    console.log("asd-error", error);
  }
};

export const updateProcessUrgency = async (id: string, isUrgent: boolean) => {
  const response = await api.patch(`/api/process/${id}/urgency`, { isUrgent });
  return response.data;
};

export const saveProcess = async (process: EditProcessCommand) => {
  try {
    const response = await api.post(`/api/process`, process);
    if (!response.data.success) {
      console.log("asd-error", response.data);
    }
    return response;
  } catch (error) {
    console.log("asd-error", error);
  }
};

export const deleteProcess = async (id: string, reason: string) => {
  try {
    const response = await api.delete(`/api/process/${id}`, {
      data: { reason } satisfies DeleteProcessCommand,
    });
    return response.data;
  } catch (error) {
    console.log("error", error);
    throw error;
  }
};

export const restoreProcess = async (id: string) => {
  try {
    const response = await api.put(`/api/process/${id}/restore`);
    return response.data;
  } catch (error) {
    console.log("error", error);
    throw error;
  }
};

export const getProcessDeletions = async (): Promise<
  ProcessDeletionViewModel[] | undefined
> => {
  try {
    const response = await api.get(`/api/process/deletions`);
    return response.data;
  } catch (error) {
    console.log("error", error);
  }
};

export const downloadFile = async (filter: DashboardQuery) => {
  try {
    const response = await api.post(`/api/process/followUp`, filter);
    if (!response.data) {
      console.log("error", response.data);
    }
    return response.data;
  } catch (error) {
    console.log("asd-error", error);
  }
};

export const exportProcessesExcel = async (filter: DashboardQuery) => {
  try {
    const response = await api.post(`/api/process/Export`, filter);
    if (!response.data) {
      console.log("error", response.data);
    }
    return response.data;
  } catch (error) {
    console.log("error", error);
  }
};

export const getProcessStatusHistory = async (processId: string) => {
  try {
    const response = await api.get(`/api/process/${processId}/status-history`);
    return response.data as ProcessStatusTimeline;
  } catch (error) {
    console.log("error", error);
    return undefined;
  }
};

export interface ProcessDocumentScan {
  documentType?: string;
  blAwbCrt?: string;
  vessel?: string;
  customsAgent?: string;
  dischargePort?: string;
  shippingDate?: string;
  arrivalDate?: string;
  containerNumber?: string;
  containerQuantity?: string;
  exporter?: string;
  incoterm?: string;
  countryOfOrigin?: string;
}

// "Ler documento (IA)": só sugere valores (BL/AWB/CRT), não persiste nada.
export const scanProcessDocument = async (file: File): Promise<ProcessDocumentScan> => {
  const formData = new FormData();
  formData.append("file", file);
  const response = await api.post("/api/process/scan-document", formData, {
    headers: { "Content-Type": "multipart/form-data" },
    timeout: 180000,
  });
  return response.data;
};
